__turbopack_context__.v({
  "root": "GlobalFallback-module-scss-module__5qlWBG__root",
});
